// extracted by mini-css-extract-plugin
module.exports = {"ad":"styles-m__ad__1MBvE","out-of-page-ad":"styles-m__out-of-page-ad__2CgdZ"};